enum UserRoles {
  VENDOR_ADMIN = "VendorAdmin",
  ADMINISTRATOR = "Administrator",
  FEATURE_VEHICLE = "Feature Vehicle",
}

export default UserRoles;
